import { render, staticRenderFns } from "./samples.vue?vue&type=template&id=766bc061&scoped=true&"
import script from "./samples.vue?vue&type=script&lang=js&"
export * from "./samples.vue?vue&type=script&lang=js&"
import style0 from "./samples.vue?vue&type=style&index=0&id=766bc061&lang=scss&scoped=true&"
import style1 from "./samples.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766bc061",
  null
  
)

export default component.exports